<template>
  <div class="dashboard">
    <!-- Date Range Filter -->
    <div class="date-filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="→"
        start-placeholder="От"
        end-placeholder="До"
        format="DD.MM.YYYY"
        value-format="YYYY-MM-DD"
        :clearable="true"
        @change="onDateChange"
        size="small"
      />
    </div>

    <!-- Stats Cards -->
    <StatsCards />

    <!-- Charts -->
    <ChartsSection :date-from="statsStore.dateFrom" :date-to="statsStore.dateTo" />

    <!-- Activity Feed -->
    <ActivityFeed />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import StatsCards from '@/components/StatsCards.vue'
import ChartsSection from '@/components/ChartsSection.vue'
import ActivityFeed from '@/components/ActivityFeed.vue'
import { useStatsStore, AUTO_REFRESH_INTERVAL_MS } from '@/stores/stats'

const statsStore = useStatsStore()

const dateRange = ref<[string, string] | null>(null)

function onDateChange(range: [string, string] | null) {
  if (range && range.length === 2) {
    statsStore.setDateRange(range[0], range[1])
  } else {
    statsStore.setDateRange(null, null)
  }
}

onMounted(() => {
  statsStore.loadAll()
  statsStore.startAutoRefresh(AUTO_REFRESH_INTERVAL_MS)
})

onUnmounted(() => {
  statsStore.stopAutoRefresh()
})
</script>

<style scoped>
.dashboard {
  max-width: 1400px;
  margin: 0 auto;
}

.date-filter-bar {
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-end;
}
</style>
